// Pioneer Cohort calendar — source: "E1X Pioneer Cohort Schedule" Google Sheet.
// All dates/times are WAT (UTC+1). Edit this file to change the public calendar at
// /pioneer-cohort-schedule; class sessions are generated from WEEKS + CLASS_GROUPS.

export const COHORT_NAME = "Pioneer Cohort";

// Two class groups, each with two 2-hour live classes a week.
export const CLASS_GROUPS = {
  A: {
    label: "Tuesday & Saturday",
    slots: [
      { day: 1, start: "19:00", end: "21:00" }, // Tue (days after the week's Monday)
      { day: 5, start: "13:00", end: "15:00" }, // Sat
    ],
  },
  B: {
    label: "Thursday & Saturday",
    slots: [
      { day: 3, start: "19:00", end: "21:00" }, // Thu
      { day: 5, start: "16:00", end: "18:00" }, // Sat
    ],
  },
};

// Timetable from 3 Nov 2026: Batch 1 = A, Batch 2 = B.
export const COURSES = [
  { slug: "ai-machine-learning", name: "AI and Machine Learning", group: "A" },
  // Data Science and AI and Machine Learning share one class (same curriculum, days and times).
  { slug: "data-science", name: "Data Science", group: "A" },
  { slug: "software-development", name: "Software Development", group: "A" },
  { slug: "cybersecurity", name: "Cybersecurity", group: "A" },
  { slug: "digital-social-marketing", name: "Digital & Social Marketing", group: "A" },
  { slug: "ui-ux-design", name: "UI/UX Design", group: "A" },
  { slug: "ai-automation", name: "AI Automation", group: "B" },
  { slug: "data-engineering", name: "Data Engineering", group: "B" },
  { slug: "data-analytics", name: "Data Analytics", group: "B" },
  { slug: "ai-product-project-management", name: "AI Product & Project Management", group: "B" },
  { slug: "devops-engineering", name: "DevOps Engineering", group: "B" },
  { slug: "ai-content-creation", name: "AI Content Creation", group: "B" },
  { slug: "ai-virtual-assistant", name: "AI Virtual Assistant", group: "B" },
];

// kind: "pre" (before classes), "break", "teaching" (classes run), "showcase".
// `monday` is the week's Monday; class dates are counted from it.
export const WEEKS = [
  { id: "pre-1", label: "Pre-cohort", kind: "pre", monday: "2026-10-05" },
  { id: "pre-2", label: "Pre-cohort", kind: "pre", monday: "2026-10-12" },
  { id: "pre-3", label: "Pre-cohort", kind: "pre", monday: "2026-10-19" },
  { id: "pre-break", label: "Break", kind: "break", monday: "2026-10-26", note: "No classes. Second orientation on Saturday." },
  { id: "w1", label: "Week 1", kind: "teaching", monday: "2026-11-02" },
  { id: "w2", label: "Week 2", kind: "teaching", monday: "2026-11-09" },
  { id: "w3", label: "Week 3", kind: "teaching", monday: "2026-11-16" },
  { id: "w4", label: "Week 4", kind: "teaching", monday: "2026-11-23" },
  { id: "w5", label: "Week 5", kind: "teaching", monday: "2026-11-30" },
  { id: "w6", label: "Week 6", kind: "teaching", monday: "2026-12-07" },
  { id: "w7", label: "Week 7", kind: "teaching", monday: "2026-12-14" },
  { id: "w8", label: "Week 8", kind: "teaching", monday: "2026-12-21" },
  { id: "xmas", label: "Christmas & New Year break", kind: "break", monday: "2026-12-28", note: "No classes. Classes resume Tuesday 5 January." },
  { id: "w9", label: "Week 9", kind: "teaching", monday: "2027-01-04" },
  { id: "w10", label: "Week 10", kind: "teaching", monday: "2027-01-11" },
  { id: "w11", label: "Week 11", kind: "teaching", monday: "2027-01-18" },
  { id: "w12", label: "Week 12", kind: "teaching", monday: "2027-01-25" },
  // The sheet labels Week 13 "Feb 1 to Feb 7" but dates every event in it Feb 9–13,
  // so the week is placed on the events' dates. Confirm with the programme team.
  { id: "w13", label: "Week 13 · Showcase", kind: "showcase", monday: "2027-02-08" },
];

// Cohort-wide events (everyone). type: kickoff | orientation | webinar | office-hours | career | showcase
export const EVENTS = [
  { date: "2026-10-09", start: "19:00", end: "20:30", type: "kickoff", title: "Kickoff session" },
  { date: "2026-10-17", start: "14:00", end: "15:30", type: "orientation", title: "First orientation" },
  { date: "2026-10-21", start: null, end: null, type: "webinar", title: "Webinar", note: "Time to be announced" },
  { date: "2026-10-31", start: "14:00", end: "15:30", type: "orientation", title: "Second orientation" },
  { date: "2026-11-29", start: "14:00", end: "15:30", type: "career", title: "Career session: Software, Engineering & Cybersecurity" },
  { date: "2026-12-11", start: "19:00", end: "20:30", type: "career", title: "Career session: Marketing & Business" },
  // Sheet places these in Weeks 9 and 11 but dates them Jan 17 and Jan 29 (Weeks 10 and 12).
  { date: "2027-01-17", start: "14:00", end: "15:30", type: "career", title: "Career session: Design & Product" },
  { date: "2027-01-29", start: "19:00", end: "20:30", type: "career", title: "Career session: Data & AI" },
  // Sheet dates both prep sessions Feb 11; Prep I sits in the Tuesday column, so Tue Feb 9 is assumed.
  { date: "2027-02-09", start: "19:00", end: "21:00", type: "showcase", title: "General showcase prep I" },
  { date: "2027-02-11", start: "19:00", end: "21:00", type: "showcase", title: "General showcase prep II" },
  { date: "2027-02-13", start: "13:00", end: "15:00", type: "showcase", title: "Capstone showcase I" },
  { date: "2027-02-13", start: "16:00", end: "18:00", type: "showcase", title: "Capstone showcase II" },
];

// Weekly office hours run every Wednesday in teaching and showcase weeks.
export const OFFICE_HOURS = { day: 2, start: "19:00", end: "20:00", title: "Office hours" };

// Notes shown on a day; classes still run unless the sheet says otherwise.
export const DAY_NOTES = {
  "2026-11-26": "US Thanksgiving",
  "2026-12-24": "Christmas Eve",
  "2026-12-25": "Christmas Day",
  "2026-12-26": "Boxing Day",
  "2027-01-16": "Nigerian national election",
};
